import { CardProps } from '@anm/components/Card';
import CardModal from '@anm/components/modals/CardModal';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { waveEventsSelectors } from '../../store/modules/waveEvents';
import { InfoBlockProps } from '../InfoBlock';
import WaveEventInfoWithButtons from '../WaveEventInfoWithButtons';

import VideoTemplate from './VideoTemplate';
import { useCurrentTemplateClear, useWaveEventDataLoadChecker } from './hooks';

export type WaveEventModalProps = {
  onModalClose: () => void;
};

const cardSettings: CardProps = {
  variant: 'transparent',
  isPadding: false
};

const WaveEventModal: FC<WaveEventModalProps> = ({ onModalClose }) => {
  const {
    title,
    previewId: templateId,
    attachments,
    description
  } = useSelector(waveEventsSelectors.selectCurrentWaveEvent);
  const isCurrentWaveEventPending = useSelector(
    waveEventsSelectors.selectCurrentWaveEventPending
  );

  useCurrentTemplateClear();
  const isDataLoaded = useWaveEventDataLoadChecker();

  const info: InfoBlockProps = {
    title,
    description,
    preview: attachments && attachments[0]
  };

  if (isCurrentWaveEventPending) return null;

  return (
    <CardModal {...{ cardSettings, onModalClose }}>
      {templateId ? (
        isDataLoaded ? (
          <VideoTemplate {...{ info, onModalClose }} />
        ) : null
      ) : (
        <WaveEventInfoWithButtons {...{ info }} onBack={onModalClose} />
      )}
    </CardModal>
  );
};

export default WaveEventModal;
